
interface IFilterButtons {
  currentFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  onClearCompleted: () => void;
  hasCompletedTodos: boolean;
}

const FilterButtons = ({
  currentFilter,
  onFilterChange,
  onClearCompleted,
  hasCompletedTodos,
}: IFilterButtons) => {
  return (
    <div className="filter-section">
      <div className="filter-buttons">
        <button
          className={`filter-btn ${currentFilter === "all" ? "active" : ""}`}
          onClick={() => onFilterChange("all")}>
          All
        </button>
        <button
          className={`filter-btn ${currentFilter === "active" ? "active" : ""}`}
          onClick={() => onFilterChange("active")}>
          Active
        </button>
        <button
          className={`filter-btn ${
            currentFilter === "completed" ? "active" : ""
          }`}
          onClick={() => onFilterChange("completed")}>
          Completed
        </button>
      </div>

      {hasCompletedTodos && (
        <button className="clear-completed-btn" onClick={onClearCompleted}>
          Clear Completed
        </button>
      )}
    </div>
  );
};

export default FilterButtons;
